import { Tipo } from "app/models/inventario/tipo";
import { Estado } from "app/models/venta/estado";

export class Constantes {
    static estadoGenericos = {  
        trabajo: 1,
        contabilizado: 2, 
        
        anulado: 3,
        nombreAnulado: 'ANULADO'
    };
    static codigoImpuestoSunat = {
        gravado: 10,
        inafecta: 30,
        exonerada: 20,
        gratuita: 21,
        exportacion: 40
    }
    static tipoSeguridad = {
        bearToken: 'Bearer ',
    };
    static api = {
        accesos: {
            TipoImpuesto: {
                GetAll: '/api/TipoImpuesto/GetAll'
            },
            LibroElectronico:{
                GetAll: '/api/libroElectronico/GetAll'
            },
            TipoProducto: {
                GetAll: '/api/TipoProducto/GetAll'
            },
            TipoDocumentoIdentidad: {
                GetAll: '/api/TipoDocumentoIdentidad/GetAll'
            },
            Moneda: {
                GetAll: '/api/Moneda/GetAll'
            },
            Login: {
                Login: '/api/Login/Login',
                Logout: '/api/Login/logout',
                RenuevaToken: '/api/Login/RenuevaToken'
            },
            Acceso: {
                GetMenu: '/api/Accesos/GetMenuFalso',
                GetMenuAdministrativoCompania: '/api/accesos/getMenuAdministrativoCompania',
                GetMenuRol: '/api/Accesos/GetMenuRol',
                Actualizar: '/api/Accesos/Actualizar'
            },
            ControlComprobante: {
                GetPeriodo: '/api/controlComprobante/GetPeriodo'
            },
            Rol: {
                Get: '/api/Rol/Get',
                GetCriterio: '/api/Rol/GetCriterio',
                GetAll: '/api/Rol/GetAll',
                Registrar: '/api/Rol/Registrar',
                Actualizar: '/api/Rol/Actualizar',
                Eliminar: '/api/Rol/Eliminar'
            },
            Cliente: {
                Get: '/api/Cliente/Get',
                GetCriterio: '/api/Cliente/GetCriterio',
                Registrar: '/api/Cliente/Registrar',
                Actualizar: '/api/Cliente/Actualizar',
                Eliminar: '/api/Cliente/Eliminar'
            },
            Usuario: {
                Get: '/api/Usuario/Get',
                GetCriterio: '/api/Usuario/GetCriterio',
                Registrar: '/api/Usuario/Registrar',
                Actualizar: '/api/Usuario/Actualizar',
                Eliminar: '/api/Usuario/Eliminar'
            },
            Compania: {
                Get: '/api/compania/get',
                FondoLogin: '/api/compania/fondoLogin',
                Actualizar: '/api/Compania/Actualizar',
                preEvaluacion: '/api/Compania/registrarPreEvaluacion',
            },
            TipoIntegracion: {
                GetAll: '/api/tipointegracion/getAll'
            },
            SerieCorrelativo: {
                Get: '/api/TipoDocumento/Get',
                GetCriterio: '/api/Compania/GetCriterio',
                Registrar: '/api/Compania/Registrar',
                Actualizar: '/api/Compania/Actualizar',
                Eliminar: '/api/Compania/Eliminar'
            },
            DocumentoElectronico: {
                Get: '/api/TipoDocumento/Get',
                GetCriterio: '/api/Compania/GetCriterio',
                Registrar: '/api/Compania/Registrar',
                Actualizar: '/api/Compania/Actualizar',
                Eliminar: '/api/Compania/Eliminar'
            },
            Ubigeo: {
                GetUbigeoAll: '/api/ubigeo/getAll'
            },
            Pais: {
                GetPais: '/api/pais/GetAll'
            },
            TipoDetraccion: {
                GetAll: '/api/TipoDetraccion/GetAll'
            },
            Estado: {
                GetAll: '/api/Estado/GetAll'
            },

            TipoNota: {
                GetAll: '/api/TipoNota/GetAll'
            },
            RelacionTemplateDocu: {
                Get: '/api/relacionTemplateDocuCompania/Get',
                GetCriterio: '/api/templateDocu/GetCriterio',
                Registrar: '/api/relacionTemplateDocuCompania/Registrar',
                Actualizar: '/api/relacionTemplateDocuCompania/Actualizar',
                Desactivar: '/api/relacionTemplateDocuCompania/desactivar'
            },
            MovimientosCobroFe: {
                Get: '/api/movimientoCobroFe/Get',
                GetCriterio: '/api/movimientoCobroFe/GetCriterio',
                Registrar: '/api/movimientoCobroFe/Registrar',
                Actualizar: '/api/movimientoCobroFe/Actualizar',
                Desactivar: '/api/movimientoCobroFe/desactivar'
            },
            culqi: {
                Get: '/api/culqi/suscripciones/get',
                GetOrder: '/api/culqi/order/get',
                InsertCargo: '/api/culqi/charges/insert',
                RegistrarSuscripcion: '/api/culqi/suscripciones/registrar',
                CancelarSuscripcion: '/api/culqi/suscripciones/cancelar'
            },
            openPay: {
                Get: '/api/culqi/suscripciones/get',
                pagoLinkCrear: '/api/openpay/pagolink/crear'
            },
        },
        Mantenedores: {
            Parametro: {
                GetByTipo: '/api/Parametro/getByTipo',
                Get: '/api/Parametro/Get',
                GetAll: '/api/parametro/GetAll',
            },
            MetodoPago: {
                GetAll: '/api/MetodoPago/GetAll'
            },
            Modulo: {
                GetAll: '/api/Modulo/GetAll',
            },
            CondicionCobro: {
                Get: '/api/CondicionCobro/Get',
                GetCriterio: '/api/CondicionCobro/GetCriterio',
                Registrar: '/api/CondicionCobro/Registrar',
                Actualizar: '/api/CondicionCobro/Actualizar',
                GetAll: '/api/CondicionCobro/GetAll',
                Eliminar: '/api/CondicionCobro/Eliminar'
            },
            TipoComprobanteModulo: {
                Actualizar: '/api/tipoComprobanteModulo/Actualizar',
                GetAll: '/api/tipoComprobanteModulo/getAll',
                GetAllSeries: '/api/tipoComprobanteModulo/getAllSeries'
            },
            TipoComprobanteSerie: {
                GetTipoComprobanteSerieAll: '/api/TipoComprobanteSerie/GetTipoComprobanteSerieAll',
            },
            UnidadMedida: {
                GetAll: '/api/UnidadMedida/GetAll'
            },

            TipoCambio: {
                Get: '/api/TipoCambio/Get',
                GetFecha: '/api/TipoCambio/GetFecha',
                GetCriterio: '/api/TipoCambio/GetCriterio',
                Registrar: '/api/TipoCambio/Registrar',
                Actualizar: '/api/TipoCambio/Actualizar',
                Eliminar: '/api/TipoCambio/Eliminar',
            },
            DataInicial: {
                GetContribuyente: '/api/datainicial/getContribuyente',
                GetProducto: '/api/datainicial/getProducto',
                GetVenta: '/api/datainicial/getVenta',
                GetCotizacion: '/api/datainicial/getCotizacion',
                GetNota: '/api/datainicial/getNota',
                GetVentaReporte: '/api/datainicial/getVentaReporte',
                GetGuia: '/api/datainicial/getGuia',
            }
        },
        Inventario: {
            Almacen: {
                GetSucursalAll: '/api/Almacen/GetSucursalAll',
                GetAll: '/api/Almacen/GetAll',
                Get: '/api/Almacen/Get',
                GetCriterio: '/api/Almacen/GetCriterio',
                Registrar: '/api/Almacen/Registrar',
                Actualizar: '/api/Almacen/Actualizar',
                Eliminar: '/api/Almacen/Eliminar',
            },
            TransferenciaProducto: {
                Get: '/api/TransferenciaProducto/Get',
                GetCriterio: '/api/TransferenciaProducto/GetCriterio',
                Registrar: '/api/TransferenciaProducto/Registrar',
                Actualizar: '/api/TransferenciaProducto/Actualizar',
                Eliminar: '/api/TransferenciaProducto/Eliminar',
            },
            NivelProducto: {
                GetCriterio: '/api/NivelProducto/GetCriterio',
                GetTipoAll: '/api/NivelProducto/GetAll',
                Registrar: '/api/NivelProducto/Registrar',
                Actualizar: '/api/NivelProducto/Actualizar',
                Eliminar: '/api/NivelProducto/Eliminar',

            },
            Marca: {
                Get: '/api/MarcaProducto/Get',
                GetAll: '/api/MarcaProducto/GetAll',
                GetCriterio: '/api/MarcaProducto/GetCriterio',
                Actualizar: '/api/MarcaProducto/Actualizar',
                Registrar: '/api/MarcaProducto/Registrar',
                Eliminar: '/api/MarcaProducto/Eliminar',
            },
            ModeloProducto: {
                Get: '/api/ModeloLineaProducto/Get',
                GetLineaAll: '/api/ModeloLineaProducto/GetAll',
                GetCriterio: '/api/ModeloLineaProducto/GetCriterio',
                Actualizar: '/api/ModeloLineaProducto/Actualizar',
                Registrar: '/api/ModeloLineaProducto/Registrar',
                Eliminar: '/api/ModeloLineaProducto/Eliminar',

            },
            Producto: {
                Get: '/api/Producto/Get',
                GetCriterio: '/api/Producto/GetCriterio',
                GetEquivalenteCriterio: '/api/Producto/GetEquivalenteCriterio',
                GetAlmacenCriterio: '/api/Producto/GetAlmacenCriterio',
                GetAlmacenAll: '/api/Producto/GetAlmacenAll',
                GetListVencer: '/api/Dashboard/GetListVencer',
                Registrar: '/api/Producto/Registrar',
                Actualizar: '/api/Producto/Actualizar',
                Eliminar: '/api/Producto/Eliminar',
            },
        },
        Cliente: {
            Get: '/api/Cliente/Get',
            GetCriterio: '/api/Cliente/GetCriterio',
            Registrar: '/api/Cliente/Registrar',
            Actualizar: '/api/Cliente/Actualizar',
            Eliminar: '/api/Cliente/Eliminar'
        },
        Compra: {
            IngresoSalida: {
                Get: '/api/IngresoSalida/Get',
                GetCriterio: '/api/IngresoSalida/GetCriterio',
                Registrar: '/api/IngresoSalida/Registrar',
                Actualizar: '/api/IngresoSalida/Actualizar',
                Eliminar: '/api/IngresoSalida/Eliminar',
            },
            Proveedor: {
                Get: '/api/Proveedor/Get',
                GetCriterio: '/api/Proveedor/GetCriterio',
                Registrar: '/api/Proveedor/Registrar',
                Actualizar: '/api/Proveedor/Actualizar',
                Eliminar: '/api/Proveedor/Eliminar',
            },
        },
        Caja: {
            Caja: {
                Get: '/api/Caja/Get',
                GetAll: '/api/Caja/GetAll',
                GetCriterio: '/api/Caja/GetCriterio',
                Registrar: '/api/Caja/Registrar',
                Actualizar: '/api/Caja/Actualizar',
                Eliminar: '/api/Caja/Eliminar',
                GetEstado: '/api/Caja/GetEstado',
                GetSiguienteCodigo: '/api/Caja/GetSiguienteCodigo',
                CambiarActivo: '/api/Caja/CambiarActivo',
            },
            Concepto: {
                Get: '/api/ConceptoCaja/Get',
                GetAll: '/api/ConceptoCaja/GetAll',
                GetCriterio: '/api/ConceptoCaja/GetCriterio',
                Registrar: '/api/ConceptoCaja/Registrar',
                Actualizar: '/api/ConceptoCaja/Actualizar',
                Eliminar: '/api/ConceptoCaja/Eliminar',
                CambiarActivo: '/api/ConceptoCaja/CambiarActivo',
            },
            Sesion: {
                Get: '/api/SesionCaja/Get',
                GetAbierta: '/api/SesionCaja/GetAbierta',
                GetCriterio: '/api/SesionCaja/GetCriterio',
                GetResumen: '/api/SesionCaja/GetResumen',
                GetUltimoCierre: '/api/SesionCaja/GetUltimoCierre',
                Abrir: '/api/SesionCaja/Abrir',
                Cerrar: '/api/SesionCaja/Cerrar',
            },
            Movimiento: {
                Get: '/api/MovimientoCaja/Get',
                GetCriterio: '/api/MovimientoCaja/GetCriterio',
                Registrar: '/api/MovimientoCaja/Registrar',
                Anular: '/api/MovimientoCaja/Anular',
            },
        },
        Facturacion: {
            Venta: {
                Get: '/api/Venta/Get',
                GetCodigo: '/api/Venta/GetCodigo',
                GetCdr: '/api/Venta/GetCdr',
                GetCriterio: '/api/Venta/GetCriterio',
                Registrar: '/api/Venta/Registrar',
                ContabilizarInterno: '/api/Venta/ContabilizarInterno',
                Actualizar: '/api/Venta/Actualizar',
                Eliminar: '/api/Venta/Eliminar',
                GetProyeccion: '/api/Dashboard/GetListProyeccion',
                GetTopProductos: '/api/Dashboard/GetTopProductos',
                GetTopClientes: '/api/Dashboard/GetTopClientes',
                GetProductoReserva: '/api/Venta/GetProductoReserva',
                LiberarReserva: '/api/Venta/liberarReserva'
            },
            CuentaCobrar: {
                GetCriterio: '/api/CuentaCobrar/GetCriterio',
                GetResumen: '/api/CuentaCobrar/GetResumen',
                GetCuotasDocumento: '/api/CuentaCobrar/GetCuotasDocumento',
                RegistrarCobro: '/api/CuentaCobrar/RegistrarCobro',
                AnularCobro: '/api/CuentaCobrar/AnularCobro',
            },
            Cotizacion: {
                Get: '/api/Cotizacion/Get',
                GetCriterio: '/api/Cotizacion/GetCriterio',
                Registrar: '/api/Cotizacion/Registrar',
                Actualizar: '/api/Cotizacion/Actualizar',
                Eliminar: '/api/Cotizacion/Eliminar',
            },
            Guia: {
                GetCriterio: '/api/guia/GetCriterio',
                Eliminar: '/api/guia/Eliminar',
                GetCdr: '/api/guia/GetCdr'
            },
            GuiaIndividual: {
                GetCriterio: '/api/guiaIndividual/GetCriterio',
                Registrar: '/api/guiaIndividual/Registrar',
                Get: '/api/guiaIndividual/Get',
                Actualizar: '/api/guiaIndividual/Actualizar',
                Eliminar: '/api/guiaIndividual/Eliminar',
                GetCdr: '/api/guiaIndividual/GetCdr'
            },
            LibroElectronico:{
                GetRegistroVenta: '/api/libroElectronico/GetRegistroVenta'
            },
            NotaCredito: {
                Get: '/api/Nota/Get',
                GetCdr: '/api/Nota/GetCdr',
                GetCriterio: '/api/Nota/GetCriterio',
                Registrar: '/api/Nota/Registrar',
                ContabilizarInterno: '/api/Nota/ContabilizarInterno',
                Actualizar: '/api/Nota/Actualizar',
                Eliminar: '/api/Nota/Eliminar'
            },
        },
        Sunat: {
            Ruc: {
                Get: '/api/Consulta/GetRUC'
            },
            Dni: {
                Get: '/api/Consulta/GetDNI'
            },
            Xml: {
                GetVentaNota: '/api/Electronico/GetVentaNotaXML',
                GetGuia: '/api/Electronico/GetGuiaXML',
                GetBaja: '/api/Electronico/GetBajaXML',
            },
            informarBaja: '/api/Electronico/InformarBajaId',
            informarSunat: '/api/Electronico/InformarVentaNotaId',
            informarGuiaSunat: '/api/Electronico/InformarGuiaId',
            ComunicacionBaja: {
                Get: '/api/comunicacionBaja/Get',
                GetCriterio: '/api/comunicacionBaja/GetCriterio',
                GetDocumentos: '/api/comunicacionBaja/GetDocumentos',
                Registrar: '/api/comunicacionBaja/Registrar',
                Eliminar: '/api/comunicacionBaja/Eliminar',
                GetCdr: '/api/comunicacionBaja/GetCdr',
            },
        },
        Notificacion: {
            enviarEmail: '/api/Email/Enviar',
        },
        Reporte: {
            Inventario: {
                GetKardex: '/api/Reporte/GetKardex',
                GetStock: '/api/Reporte/GetStock',
                GetHistorialTransferencia: '/api/Reporte/GetHistorialTransferencia',
                GetTransferencia: '/api/Reporte/GetTransferencia',
                GetIngresoSalida: '/api/Reporte/GetIngresoSalida',
            },
            Facturacion: {
                GetVenta: '/api/Reporte/GetVenta',
                GetRegistroVenta: '/api/Reporte/GetRegistroVenta',
                GetDescuento: '/api/Reporte/GetDescuento',
                GetFacturaBoleta: '/api/Reporte/GetFacturaBoleta',
                GetNotaCreditoDebito: '/api/Reporte/GetCreditoDebito',
                GetGuiaRemision: '/api/Reporte/GetGuiaRemision',
                GetVentaCliente: '/api/Reporte/GetVentaCliente',
                GetTemplatedocpreview: '/api/Reporte/templatedocpreview',
            },
            Cotizacion: {
                GetCotizacion: '/api/Reporte/GetCotizacion',
            }
        }
    };
    static ruteo = {
        sistema: {
            base: 'sistema',
            dashboard: 'dashboard',
            serieCorrelativo: 'serie-correlativo',
            tipoCambio: {
                base: 'tipo-cambio',
                registrar: 'registrar',
            },
            compania: {
                base: 'compania',
                registrar: 'registrar',
            },
            rol: {
                base: 'rol',
                registrar: 'registrar'
            },
            usuario: {
                base: 'usuario',
                registrar: 'registrar'
            },
            acceso: 'acceso',
            cuenta: 'cuenta',
            suscripcion: 'suscripcion'
        },

        inventario: {
            base: 'inventario',
            producto: {
                base: 'producto',
                listar: 'listar',
                registrar: 'registrar',
            },
            proveedor: {
                base: 'proveedor',
                listar: 'listar',
                registrar: 'registrar',
            },
            maestros: {
                base: 'maestros',
                marcaListar: 'marca-listar',
                marcaRegistrar: 'marca-registrar',
                modeloListar: 'modelo-listar',
                modeloRegistrar: 'marca-registrar',
                nivelProducto: 'nivel-producto',
            },
            almacen: {
                base: 'almacen',
                registrar: 'registrar',
                listar: 'listar'
            },
            ingresoSalida: {
                base: 'ingreso-salida',
                registrar: 'registrar'
            },
            transferenciaProducto: {
                base: 'transferencia-producto',
                registrar: 'registrar'
            },
        },
        venta: {
            base: 'venta',
            cliente: {
                base: 'cliente',
                listar: 'listar',
                registrar: 'cliente-registrar',
            },
            condicionCobro: {
                base: 'condicion-cobro',
                listar: 'listar',
                registrar: 'registrar',
            },
            documento: {
                base: 'documento',
                listar: 'listar',
                registrar: 'registrar',
            },
            cotizacion: {
                base: 'cotizacion',
                listar: 'listar',
                registrar: 'registrar',
            },
            cuentasCobrar: {
                base: 'cuentas-cobrar',
                listar: 'listar',
                registrar: 'registrar',
            },
            tipoComprobante: 'tipo-comprobante',
            tipoimpuesto: {
                base: 'tipo-impuesto',
                listar: 'listar',
                registrar: 'registrar'
            },
            moneda: {
                base: 'moneda',
                listar: 'listar',
                registrar: 'registrar'
            },
            Facturacion: {
                consultardocumento: 'consultar-documento'
            },
            notaCreditoDebito: {
                base: 'nota-credito-debito',
                registrar: 'registrar',
            },
            guiaremision: {
                base: 'guia-remision',
                registrar: 'registrar',
                listar: 'listar',
            },
        },
        caja: {
            base: 'caja',
            sesion: 'sesion',
            apertura: 'apertura',
            cierre: 'cierre',
            historial: 'historial',
            movimiento: 'movimiento',
            maestroCaja: {
                base: 'cajas',
                registrar: 'registrar',
            },
            concepto: {
                base: 'conceptos',
                registrar: 'registrar',
            },
        },
        reporte: {
            base: 'reporte',
            venta: 'venta',
            kardex: 'kardex',
            stock: 'stock',
            transferencia: 'transferencia',
            descuento: 'descuento',
            ventaCliente: 'venta-cliente',

        },
        sunat: {
            base: 'sunat',
            comunicacionBaja: {
                base: 'comunicacion-Baja',
                registrar: 'registrar'
            },
            libroElectronico: {
                base: 'libro-electronico'
            },
        },
        adicionales: {
            base: 'adicional',
            disenioComprobante: {
                base: 'disenio-comprobante',
                registrar: 'registrar'
            },
        }
    };

    static resultadoSistema = {
        ok: 'Ok',
        error: 'Error',
        badResquest: 'BadResquest',
        advertencia: 'BadResquest',
    };
    static dinamico = {
        tipo: {
            input: 'input',
            select: 'select',
            checkbox: 'checkbox',
            date: 'date',
        },
        inputType: {
            text: 'text',
            password: 'password',
            email: 'email',
            number: 'number',
        },
        gruposInputs: {
            grupo1: 'grupo1',
            grupo2: 'grupo2',
            grupo3: 'grupo3',
            grupo4: 'grupo4',
            grupo5: 'grupo5',
            grupo6: 'grupo6',
            grupo7: 'grupo7',
            grupo8: 'grupo8',
            grupo9: 'grupo9',
            grupo10: 'grupo10',
        },
        nameValidations: {
            required: 'required',
            maxlength: 'maxlength',
            minlength: 'minlength',
        },
    };
    static imagenesComunes = {
        logo: 'assets/images/logos/Facturana.png'
    };

    static tipoBusquedaProducto = {
        //estandar: 'Estandar',
        todos: 0,
        inventariable: 1,
        servicio: 2,
        stock: 3
    };

    static accionModal = {
        agregar: 'Agregar',
        editar: 'Editar',
        cancel: 'Cancel',
        buscar: 'Buscar',
    };
    static tipoProducto = {
        inventariable: 1,
        codigoServicio: 2,
        servicioId: '6304f349647bd5d6c5f9969b',
        nombreServicio: 'SERVICIO'
    };
    static tipoIdentidad = {
        ruc: 6,
        dni: 1,
        noDomiciliado: 0
    };

    static tipoIngresoSalida = {
        ingreso: 1,
        salida: 2,
    };

    static pais = {
        peru: 'PE',
    };

    static tipoColumnasMatTable = {
        InputNumerico: 'InputNumerico',
        InputDecimalThree: 'InputDecimalThree',
        InputDecimalFour: 'InputDecimalFour',
        InputDecimalTwo: 'InputDecimalTwo',
        InputTexto: 'InputTexto',
        CheckBox: 'CheckBox',
        CheckBoxPermiso : 'CheckBoxPermiso',
        Combo: 'Combo',
        ComboSecundario: 'ComboSecundario',
        InputFecha: 'InputFecha',
        Pipe: 'Pipe',
        PipeDate: 'PipeDate'
    };
    static codigosDocumentoElectronico = {
        boletaVenta: '03',
        factura: '01',
        notaCredito: '07',
        notaDebito: '08',
        guiaRemision: '09',
        cotizacion: '91'
    };

    static unidadMedida = {
        codigoServicio: "ZZ",
        nombreServicio: 'SERVICIOS',
        servicioId: '619406f5da2c8b77c9577788'
    }
    static documentosElectronicosVenta = [
        {
            codigoTip: '03',
            nombre: 'Boleta Electrónica',
            comprobanteModuloId: 2
        },
        {
            codigoTip: '01',
            nombre: 'Factura Electrónica',
            comprobanteModuloId: 1
        }
    ];

    static headerHttpEs = {
        companiaId: 'CompaniaId'
    };

    static tipoIdentidadLongitud = {
        ruc: 11,
        dni: 8,
    };
    static MonedasCodigo = {
        soles: 'PEN'
    };

    static MetodoPago = {
        efectivo: "62361d1c636234a5f714ba8f",
        descripcionEfectivo: 'EFECTIVO SOLES'
    }

    static Modulos = {
        ventaId: '619406f5da2c8b77c9577741', // Valores en la DB
        notaID: '619406f5da2c8b77c9577745',
        venta: 1,
        nota: 2,
    };
    static Parametros = {
        general: 'General',
    };

    static estadosDocumentoEletronico = {
        Pendiente: 1,
        nombrePendiente: 'Pendiente',
        Autorizado: 2,
        nombreAutorizado: 'Autorizado',
        Rechazado: 3,
        nombreRechazado: 'Rechazado',
        EnProceso: 4,
        nombreEnProceso: 'En Proceso',
        Eliminado: 0,
        nombreEliminado: 'Eliminado',
        Baja: 5,
        nombreBaja: 'Baja'
    };

    static estadosFiltroElectronico: Estado[] = [
        { estadoId: 1, nombre: 'PENDIENTE' },
        { estadoId: 2, nombre: 'AUTORIZADO' },
        { estadoId: 3, nombre: 'RECHAZADO' },
        { estadoId: 0, nombre: 'ELIMINADO' },
        { estadoId: 5, nombre: 'BAJA' }
      ];

      static estadosFiltroCotizacion: Estado[] = [
        { estadoId: 1, nombre: 'PENDIENTE' },
        { estadoId: 2, nombre: 'GENERADO' },
        { estadoId: 0, nombre: 'ELIMINADO' },
      ];

    // Caja: apertura, movimientos y cierre
    static estadosSesionCaja = {
        abierta: 1,
        nombreAbierta: 'ABIERTA',
        cerrada: 2,
        nombreCerrada: 'CERRADA'
    };

    static tiposMovimientoCaja = {
        apertura: 0,
        ingreso: 1,
        egreso: 2,
        venta: 3,
        rutaIngreso: 'ingreso',
        rutaEgreso: 'egreso',
        nombres: { 0: 'APERTURA', 1: 'INGRESO', 2: 'EGRESO', 3: 'VENTA' }
    };

    static estadosMovimientoCaja = {
        anulado: 0,
        registrado: 1
    };

    static denominacionesEfectivo = {
        billetes: [200, 100, 50, 20, 10],
        monedas: [5, 2, 1, 0.5, 0.2, 0.1]
    };

    static turnosCaja = ['MAÑANA', 'TARDE', 'NOCHE', 'ÚNICO'];

    static destinosEfectivoCaja = ['TESORERÍA / ADMINISTRACIÓN', 'DEPÓSITO EN BANCO', 'CAJA FUERTE'];

    static configuracionCaja = {
        diferenciaMaximaSinAutorizacion: 10
    };

    // Venta al contado o al crédito en cuotas
    static formasPagoVenta = {
        contado: 'CONTADO',
        credito: 'CREDITO'
    };

    static estadosCuota = {
        anulada: 0,
        pendiente: 1,
        parcial: 2,
        pagada: 3,
        nombres: { 0: 'ANULADA', 1: 'PENDIENTE', 2: 'PARCIAL', 3: 'PAGADA' }
    };

    static frecuenciasCuota = [
        { codigo: 'PERSONALIZADA', nombre: 'PERSONALIZADA', dias: 0 },
        { codigo: 'SEMANAL', nombre: 'SEMANAL', dias: 7 },
        { codigo: 'QUINCENAL', nombre: 'QUINCENAL', dias: 15 },
        { codigo: 'MENSUAL', nombre: 'MENSUAL', dias: 0 }
    ];

    // Conversión de cotización a venta
    static cotizacionVenta = {
        diasVigencia: 7,          // días de validez de una cotización desde su emisión
        estadoPendiente: 1,
        estadoGenerado: 2,
        nombreGenerado: 'GENERADO',
        claveAlmacenamiento: 'esCotizacionVenta'
    };


    static estadosIngresoFiltroElectronico: Estado[] = [
        { estadoId: 1, nombre: 'TRABAJO' },
        { estadoId: 2, nombre: 'CONTABILIZADO' },
        { estadoId: 3, nombre: 'ANULADO' }
      ];
      
    static tiposIngresoSalida: Tipo[] = [
        { tipoId: 1, nombre: 'INGRESO' },
        { tipoId: 2, nombre: 'SALIDA' }
      ];

    static parametrosSistema = {
        uniMedDefault: 'UniMedDefault'
    };
    static ambiente = {
        local: "LOCAL",
        produccion: "PRODUCCION"
    };
    static culqi = {
        auth: {
            id: 'pk_test_f4c972acfa9ab030'
        },
        path: 'assets/js/culqi.js'
    };
    static tiposPlanes = [
        {
            _id: '651dd03f043f9da13d082e2c',
            costo_plan: 0,
            nombrePlan: 'Gratis',
            periodo_inicial_gratis: 30,
            descripcion: 'Emprendedores',
            incluye: [
                "Vende hasta S/ 15,000.",
                "Hasta 150 Comprobantes/Mes.",
                "Gratis.",
                "Reporteria Básica.",
                "1 Usuario, 1 Sucursal, 100 Productos.",
                "Certificado digital gratis previa evaluación de SUNAT.",
                "Genera Facturas, Boletas, Nota Crédito, Nota Débito.",
                "Impresiones en formato Ticket o A4, con tu logo.",
                "Conexión con SUNAT",
                "Videotutoriales",
                "Soporte vía chat"
            ]
        },
        {
            _id: '651dd04f043f6da23d082e2c',
            costo_plan: 35,
            nombrePlan: 'Básico',
            descripcion: 'Emprendedores y pequeños negocios',
            culqiPlanId: "pgeoezcdctca1pef2rcr",
            periodo_inicial_gratis: 30,
            incluye: [ 
                "Vende hasta S/ 35,000.",
                "Hasta 500 Comprobantes/Mes.",
                "Gratis primer mes.",
                "Reporteria Avanzada.",
                "2 Usuario, 2 Sucursales, 300 Productos.",
                "Certificado digital gratis previa evaluación de SUNAT.",
                "Genera Facturas, Boletas, Nota Crédito, Nota Débito.",
                "Impresiones en formato Ticket o A4, con tu logo.",
                "Conexión con NubeFacT",
                "Videotutoriales",
                "Soporte vía chat"
            
            ]
        },
        {
            _id: '652dd03f013f7da11d081e6c',
            costo_plan: 45,
            nombrePlan: 'Medium C',
            descripcion: 'Pequeños negocios',
            culqiPlanId: "plhroeonkej31unekfho",
            periodo_inicial_gratis: 30,
            incluye: [ 
                "Vende hasta S/ 45,000.",
                "Hasta 750 Comprobantes/Mes.",
                "Gratis primer mes.",
                "Reporteria Avanzada.",
                "2 Usuario, 2 Sucursales, 600 Productos.",
                "Certificado digital gratis previa evaluación de SUNAT.",
                "Genera Facturas, Boletas, Nota Crédito, Nota Débito.",
                "Impresiones en formato Ticket o A4, con tu logo.",
                "Conexión con NubeFacT",
                "Videotutoriales",
                "Soporte vía chat"
            ]
        },
        {
            _id: '621dd77f043f8da12d082e2c',
            costo_plan: 55,
            nombrePlan: 'Medium B',
            descripcion: 'Pequeños negocios',
            culqiPlanId: "pme8uzabtdbb5y4okjqz",
            periodo_inicial_gratis: 30,
            incluye: [
                "Vende hasta S/ 55,000.",
                "Hasta 1000 Comprobantes/Mes.",
                "Gratis primer mes.",
                "Reporteria Avanzada.",
                "3 Usuario, 3 Sucursales, 800 Productos.",
                "Certificado digital gratis previa evaluación de SUNAT.",
                "Genera Facturas, Boletas, Nota Crédito, Nota Débito.",
                "Impresiones en formato Ticket o A4, con tu logo.",
                "Conexión con NubeFacT",
                "Videotutoriales",
                "Soporte vía chat"
            ]
        },
        {
            _id: '551dd99f042f2ca14d072e2c',
            costo_plan: 65,
            nombrePlan: 'Medium A',
            descripcion: 'Pequeños negocios',
            culqiPlanId: "pjtplthankeubmpgju0y",
            periodo_inicial_gratis: 8,
            incluye: [ 
                "Vende hasta S/ 65,000.",
                "Hasta 1250 Comprobantes/Mes.",
                "Prueba gratis de 8 dias.",
                "Reporteria Avanzada.",
                "3 Usuario, 3 Sucursales, 1000 Productos.",
                "Certificado digital gratis previa evaluación de SUNAT.",
                "Genera Facturas, Boletas, Nota Crédito, Nota Débito.",
                "Impresiones en formato Ticket o A4, con tu logo.",
                "onexión con NubeFacT",
                "Videotutoriales",
                "Soporte vía chat"
            ]
        },
        {
            _id: '651dd43f053f1da16d082e2c',
            costo_plan: 75,
            nombrePlan: 'Avanzado B',
            descripcion: 'Pequeñas y medianas empresas',
            culqiPlanId: "piqflfyuobmmfozdlgrc",
            periodo_inicial_gratis: 8,
            incluye: [
                "Vende hasta S/ 75,000.",
                "Hasta 1500 Comprobantes/Mes.",
                "Prueba gratis de 8 dias.",
                "Reporteria Avanzada.",
                "4 Usuario, 4 Sucursales, 1200 Productos.",
                "Certificado digital gratis previa evaluación de SUNAT.",
                "Genera Facturas, Boletas, Nota Crédito, Nota Débito.",
                "Impresiones en formato Ticket o A4, con tu logo.",
                "Conexión con NubeFacT",
                "Videotutoriales",
                "Soporte vía chat"
            ]
        },
        {
            _id: '851dd23f025f9da17d082e2c',
            costo_plan: 85,
            nombrePlan: 'Avanzado A',
            descripcion: 'Pequeñas y medianas empresas',
            culqiPlanId: "pdffkvupzzlg9dvjiwox",
            periodo_inicial_gratis: 8,
            incluye: [
                "Vende hasta S/ 85,000.",
                "Hasta 1750 Comprobantes/Mes.",
                "Prueba gratis de 8 dias.",
                "Reporteria Avanzada.",
                "4 Usuario, 4 Sucursales, 1500 Productos.",
 
                "Certificado digital gratis previa evaluación de SUNAT.",
                "Genera Facturas, Boletas, Nota Crédito, Nota Débito.",
                "Impresiones en formato Ticket o A4, con tu logo.",
                "Conexión con NubeFacT",
                "Videotutoriales",
                "Soporte vía chat"

            ]
        },
        {
            _id: '691dd13f033f9da18d085e1c',
            costo_plan: 115,
            nombrePlan: 'Premiun',
            descripcion: 'Medianas empresas',
            culqiPlanId: "p8qdmxygvlcgv09mboep",
            periodo_inicial_gratis: 8,
            incluye: [
                "Vende sin límites.",
                "Comprobantes Ilimitados.",
                "Prueba gratis de 8 dias.",
                "Reporteria Avanzada.",
                "Usuarios, Sucursales, Productos Ilimitados.",
 
                "Certificado digital gratis previa evaluación de SUNAT.",
                "Genera Facturas, Boletas, Nota Crédito, Nota Débito.",
                "Impresiones en formato Ticket o A4, con tu logo.",
                "Conexión con NubeFacT",
                "Videotutoriales",
                "Soporte vía chat"

            ]
        }
    ]
}